(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  if (window.EcoflussoB2BInquiryInitialized) return;
  window.EcoflussoB2BInquiryInitialized = true;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data || !data.sectionId || !data.variant) return;

    const productInfo =
      document.getElementById(`MainProduct-${data.sectionId}`) ||
      document.querySelector(`product-info[data-section="${data.sectionId}"]`);
    if (!productInfo) return;

    const inquiryLinks = productInfo.querySelectorAll('[data-b2b-inquiry-link]');
    if (!inquiryLinks.length) return;

    const inquirySkus = productInfo.querySelectorAll('[data-b2b-inquiry-sku]');
    const inquirySkuRows = productInfo.querySelectorAll('[data-b2b-inquiry-sku-row]');
    const inquiryModels = productInfo.querySelectorAll('[data-b2b-inquiry-model]');
    const inquiryModelRows = productInfo.querySelectorAll('[data-b2b-inquiry-model-row]');
    const selectedModel = data.variant.title && data.variant.title !== 'Default Title' ? data.variant.title : '';

    inquiryLinks.forEach((inquiryLink) => {
      const inquiryUrl = new URL(inquiryLink.href, window.location.origin);
      const productUrl = new URL(inquiryLink.dataset.b2bInquiryProductUrl || window.location.href, window.location.origin);
      const ariaBase = inquiryLink.dataset.b2bInquiryAriaLabelBase;
      const ariaModelLabel = inquiryLink.dataset.b2bInquiryModelLabel;
      const ariaSkuLabel = inquiryLink.dataset.b2bInquirySkuLabel;
      const ariaProductTitle = inquiryLink.dataset.b2bInquiryProductTitle;

      productUrl.hash = '';
      productUrl.searchParams.set('variant', data.variant.id);

      if (selectedModel) {
        inquiryUrl.searchParams.set('model', selectedModel);
      } else {
        inquiryUrl.searchParams.delete('model');
      }

      if (data.variant.sku) {
        inquiryUrl.searchParams.set('sku', data.variant.sku);
      } else {
        inquiryUrl.searchParams.delete('sku');
      }

      inquiryUrl.searchParams.set('product_url', productUrl.toString());
      inquiryLink.href = inquiryUrl.toString();

      if (ariaBase && ariaProductTitle) {
        const ariaModelText = selectedModel && ariaModelLabel ? ` - ${ariaModelLabel}: ${selectedModel}` : '';
        const ariaSkuText = data.variant.sku && ariaSkuLabel ? ` - ${ariaSkuLabel}: ${data.variant.sku}` : '';
        inquiryLink.setAttribute('aria-label', `${ariaBase}: ${ariaProductTitle}${ariaModelText}${ariaSkuText}`);
      }
    });

    if (data.variant.sku) {
      inquirySkus.forEach((inquirySku) => {
        inquirySku.textContent = data.variant.sku;
      });
      inquirySkuRows.forEach((inquirySkuRow) => {
        inquirySkuRow.hidden = false;
      });
    } else {
      inquirySkus.forEach((inquirySku) => {
        inquirySku.textContent = '';
      });
      inquirySkuRows.forEach((inquirySkuRow) => {
        inquirySkuRow.hidden = true;
      });
    }

    if (selectedModel) {
      inquiryModels.forEach((inquiryModel) => {
        inquiryModel.textContent = selectedModel;
      });
      inquiryModelRows.forEach((inquiryModelRow) => {
        inquiryModelRow.hidden = false;
      });
    } else {
      inquiryModels.forEach((inquiryModel) => {
        inquiryModel.textContent = '';
      });
      inquiryModelRows.forEach((inquiryModelRow) => {
        inquiryModelRow.hidden = true;
      });
    }
  });
})();
